import { Helmet } from "react-helmet-async";
import { useAuth } from "~/presentation/core/contexts/AuthContext";
import { SignInContainer } from "./SignInContainer";
import React from "react";

export const SignInPage = () => {
  const { signIn } = useAuth();

  return (
    <React.Fragment>
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-17366663597"
        />
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'AW-17366663597');
          `}
        </script>
      </Helmet>
      <SignInContainer onSignIn={signIn} />
    </React.Fragment>
  );
};
